import {
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAIL,
  ADMIN_LOGOUT,
} from "../Contans/AdminContans";

export const adminReducer = (state={admin:{}},action) => {
  switch (action.type) {
    case ADMIN_LOGIN_REQUEST:
      return {
        loading: true,
        isAuthenticated: false,
      };
    case ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        admin: action.payload,
      };
    case ADMIN_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        admin: null,
        error: action.payload,
      };
    case ADMIN_LOGOUT:
      return {
        loading: false,
        isAuthenticated: false,
        admin:null,
      }
    default:
      return state;
  }
}